export const SET_NAVIGATION_JSON = 'SET_NAVIGATION_JSON'
export const SET_NAVIGATION_RESULT = 'SET_NAVIGATION_RESULT'

export const setNavigationJson = (data) => ({ type: SET_NAVIGATION_JSON, value: data });



export const setNavigationResult = (data) => ({ type: SET_NAVIGATION_RESULT, value: data });


